import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Backdrop,
  Button,
  ChartsSetWrapperNew,
  Divider,
  DropdownMenuNew,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  emailClickedStart,
  emailOpenedStart,
  emailPermanentFailedStart,
  emailsFailedStart,
  emailSpamComplainedStart,
  emailsQueuedStart,
  emailsSentStart,
  emailsSkippedStart,
  emailTemporaryFailedStart,
  emailUnsubScribeStart,
  recruiterEmailDelivaryReportNewStart,
  recruiterEmailDelivaryReportStart,
} from "../../../../redux/slices/reports/reportsSlice";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
import { usePagination } from "../../../../hooks";
import { formatWords2 } from "../../../../utils/stringUtils";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import dayjs from "dayjs";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { fetchEmailReportDataApi } from "../../../../redux/slices/reports/reportsApi";
import * as XLSX from "xlsx";

const EmailReports = ({ selectedReport, setSelectedReport }) => {
  const dispatch = useDispatch();
  const { recruiterEmailDelivaryReportNewData } =
    useSelector((state) => state.reports) || {};
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.emailcampaignsdata?.data || 0;
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const {
    page: canPage,
    limit: canLimit,
    setPage: canSetPage,
    handleLimitChange: canHandleLimitChange,
  } = usePagination(10, (newPage, newLimit) => {});

  const [dateRange, setDateRange] = useState(() => {
    return { from: new Date(), to: new Date() };
  });
  const [recruiterRows, setRecruiterRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [tableType, setTableType] = useState("table");
  const [isModelopen, setIsModelOpen] = useState(false);
  const [emailRowMappedData, setEmailRowMappedData] = useState([]);
  const [activeEmailRow, setActiveEmailRow] = useState();
  const [totalEmailDataCount, setTotalEmailDataCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const emailReportData = useSelector((state) => state.reports) || [];
  const [statusKey, setStatusKey] = useState(0);
  const [searchValue, setSearchValue] = useState("");

  const handleDateRangeChange = (range) => {
    if (!range || !range.from || !range.to) return;
    const fromISO = range.from ? range.from : null;
    const toISO = range.to ? range.to : null;
    setDateRange({ from: fromISO, to: toISO });
  };
  const { user } = useSelector((state) => state.auth);

  const reportOptions = [
    {
      id: "reports_ats_emailreport_recruiteremaildelivaryreport",
      name: "Recruiter Email Delivary Report",
    },
  ];

  const rows = reportOptions.map((report, i) => ({
    id: i + 100,
    reportName: report,
    category: "Email Report",
    type: "Standard Reports",
    // Favourite: "iii",
  }));

  const candidateEmailStatus = {
    1: emailsQueuedStart,
    2: emailsSentStart,
    3: emailsFailedStart,
    4: emailsSentStart,
    //5: "DELIVERED",
    6: emailOpenedStart,
    7: emailClickedStart,
    8: emailTemporaryFailedStart,
    9: emailPermanentFailedStart,
    10: emailSpamComplainedStart,
    11: emailUnsubScribeStart,
  };

  const emailSagaData = {
    //0: "none",
    1: "emailsQueued",
    2: "emailsSent",
    3: "emailsFailed",
    4: "emailsSent",
    //5: "emailsDelivered",
    6: "emailOpened",
    7: "emailClicked",
    8: "emailTemporaryFailed",
    9: "emailPermanentFailed",
    10: "emailSpamComplained",
    11: "emailUnsubScribe",
  };

  const statusMap = {
    1: "Queued",
    2: "Sent",
    3: "Fail",
    4: "Delivered",
    //5: "Delivered",
    6: "Opened",
    7: "Clicked",
    8: "Temporary Failed",
    9: "Permanent Failed",
    10: "Spam Complained",
    11: "Email Unsubscribe",
  };

  const columns = [
    {
      key: "reportName",
      label: "Report Name",
      render: (row) => (
        <div
          className="text-blue-600 cursor-pointer"
          onClick={() => setSelectedReport(row?.reportName?.id)}
        >
          {row?.reportName?.name}
        </div>
      ),
    },
    {
      key: "category",
      label: "Category",
    },
    {
      key: "type",
      label: "Type",
    },
    {
      key: "Favourite",
      label: "Favourite",
      render: (row) => (
        <Button
          type="icon"
          icon={"star"}
          variant="text"
          size="md-lg"
          color="black"
          className="text-gray-400"
          // onClick={() => console.log("delete", row)}
        />
      ),
    },
  ];

  const columns2 = [
    {
      key: "date",
      label: "Date",
      width: "text-nowrap!",
    },
    {
      key: "recruiterName",
      label: "Recruiter Name",
      width: "text-nowrap!",
    },
    {
      key: "selectedEmailsCount",
      label: "Selected Emails Count",
      width: "text-nowrap!",
    },
    {
      key: "emailsSkipped",
      label: "Skipped Emails",
      width: "text-nowrap!",
      // render: (row) => (
      //   <p className="text-info-400 cursor-pointer" onClick={() => {
      //     setIsModelOpen(true)
      //     setActiveEmailRow(row);
      //     setTotalEmailDataCount(row?.emailsSkipped)
      //   }}>{row?.emailsSkipped}</p>
      // ),
    },
    {
      key: "emailsQueued",
      label: "Emails Queued",
      render: (row) =>
        row?.emailsQueued ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailsQueued);
              setStatusKey(1);
            }}
          >
            {row?.emailsQueued}
          </p>
        ) : (
          row?.emailsQueued
        ),
    },
    {
      key: "emailsSent",
      label: "Emails Delivered",
      render: (row) =>
        row?.emailsSent ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailsSent);
              setStatusKey(2);
            }}
          >
            {row?.emailsSent}
          </p>
        ) : (
          row?.emailsSent
        ),
    },
    {
      key: "emailsFailed",
      label: "Emails Failed",
      render: (row) =>
        row?.emailsFailed ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailsFailed);
              setStatusKey(3);
            }}
          >
            {row?.emailsFailed}
          </p>
        ) : (
          row?.emailsFailed
        ),
    },
    {
      key: "emailClicked",
      label: "Emails Clicked",
      render: (row) =>
        row?.emailClicked ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailClicked);
              setStatusKey(7);
            }}
          >
            {row?.emailClicked}
          </p>
        ) : (
          row?.emailClicked
        ),
    },
    {
      key: "emailOpened",
      label: "Emails Opened",
      render: (row) =>
        row?.emailOpened ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailOpened);
              setStatusKey(6);
            }}
          >
            {row?.emailOpened}
          </p>
        ) : (
          row?.emailOpened
        ),
    },
    {
      key: "emailTemporaryFailed",
      label: "Emails Temporary Failed",
      render: (row) =>
        row?.emailTemporaryFailed ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailTemporaryFailed);
              setStatusKey(8);
            }}
          >
            {row?.emailTemporaryFailed}
          </p>
        ) : (
          row?.emailTemporaryFailed
        ),
    },
    {
      key: "emailPermanentFailed",
      label: "Emails Permanent Failed",
      render: (row) =>
        row?.emailPermanentFailed ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailPermanentFailed);
              setStatusKey(9);
            }}
          >
            {row?.emailPermanentFailed}
          </p>
        ) : (
          row?.emailPermanentFailed
        ),
    },
    {
      key: "emailSpamComplained",
      label: "Emails Spam Complained",
      render: (row) =>
        row?.emailSpamComplained ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailSpamComplained);
              setStatusKey(10);
            }}
          >
            {row?.emailSpamComplained}
          </p>
        ) : (
          row?.emailSpamComplained
        ),
    },
    {
      key: "emailUnsubScribe",
      label: "Emails UnSubscribe",
      render: (row) =>
        row?.emailUnsubScribe ? (
          <p
            className="text-info-400 cursor-pointer"
            onClick={() => {
              setIsModelOpen(true);
              setActiveEmailRow(row);
              setTotalEmailDataCount(row?.emailUnsubScribe);
              setStatusKey(11);
            }}
          >
            {row?.emailUnsubScribe}
          </p>
        ) : (
          row?.emailUnsubScribe
        ),
    },
    {
      key: "Favourite",
      label: "Favourite",
      render: (row) => (
        <Button
          type="icon"
          icon={"star"}
          variant="text"
          size="md-lg"
          color="black"
          className="text-gray-400"
          // onClick={() => console.log("delete", row)}
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);
  const fetchRecruiterEmailDelivaryReports = (filter) => {
    try {
      setLoading(true);
      const payload = {
        // coll: "CandidateEmailLog",
        // fil: {
        //   addedOn: { type: "CANDIDATE_EMAIL_DELIVERY_REPORT", value: [getStartOfDay(dateRange?.from), getEndOfDay(dateRange?.to)], ...( userId && {userId: userId}) }
        // },
        // useAggregate: true,
        // lim: limit,
        // extret: "uiid firstName lastName role.type"
        coll: "EmailCampaign",
        fil: filter,
        //useAggregate: true,
        ret: "addedBy uiid emailsSelected skipped skippedDetails sentDetails addedOn",
        pg: page,
        lim: limit,
        extret: "uiid firstName lastName role.type",
        useAggregate: true,
        errorHandler: true,
      };
      dispatch(recruiterEmailDelivaryReportNewStart(payload));
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let filter;
    let userId = user?.data?.role?.type == 4 ? user?.data?.uiid : "";
    if (searchValue.length > 1) {
      filter = {
        addedOn: {
          type: "EMAIL_CAMPAIGN_SEARCH",
          value: {
            from: getStartOfDay(dateRange?.from),
            to: getEndOfDay(dateRange?.to),
            search: searchValue,
            ...(userId && { addedBy: userId }),
          },
        },
      };
    } else if (searchValue.length === 0) {
      // filter = {
      //   addedOn: {
      //     type: "DATE_RANGE",
      //     value: {
      //       from: getStartOfDay(dateRange?.from),
      //       to: getEndOfDay(dateRange?.to)
      //     },
      //     ...(userId && {
      //       addedBy: {
      //         type: "NONE",
      //         value: userId
      //       }
      //     })
      //   }
      // }
      filter = {
        addedOn: {
          type: "EMAIL_CAMPAIGN_SEARCH",
          value: {
            from: getStartOfDay(dateRange?.from),
            to: getEndOfDay(dateRange?.to),
            //search: searchValue,
            ...(userId && { addedBy: userId }),
          },
        },
      };
    }
    if (searchValue.length > 1 || searchValue.length === 0) {
      fetchRecruiterEmailDelivaryReports(filter);
      dispatch(
        totalCountStart({
          collection: "emailcampaigns",
          coll: "EmailCampaign",
          tname: "emailcampaignsdata",
          filters: filter,
          app: "ats",
          useAggregate: true,
        }),
      );
    }
  }, [dateRange, limit, page, searchValue]);

  useEffect(() => {
    const rows = (recruiterEmailDelivaryReportNewData || [])?.map(
      (report, i) => ({
        id: i + 100,
        date: convertFromUTC(report?.addedOn),
        recruiterName:
          formatWords2(report?.addedBy?.firstName) +
          " " +
          formatWords2(report?.addedBy?.lastName),
        selectedEmailsCount: report?.emailsSelected || 0,
        emailsSkipped: report?.skipped || 0,
        emailsQueued: report?.sentDetails?.queued || 0,
        emailsSent: report?.sentDetails?.sent || 0,
        emailsFailed: report?.sentDetails?.internalfailed || 0,
        emailOpened: report?.sentDetails?.opened || 0,
        emailClicked: report?.sentDetails?.clicked || 0,
        emailTemporaryFailed: report?.sentDetails?.softBounce || 0,
        emailPermanentFailed: report?.sentDetails?.hardBounce || 0,
        emailSpamComplained: report?.sentDetails?.complained || 0,
        emailUnsubScribe: report?.sentDetails?.unsubscribe || 0,
        uiid: report?.uiid,
      }),
    );
    setRecruiterRows(rows);
  }, [recruiterEmailDelivaryReportNewData]);

  //chart data build
  const getDateList = (from, to) => {
    if (!from || !to) return [];

    const start = dayjs(from).startOf("day");
    const end = dayjs(to).startOf("day");

    const dates = [];
    let current = start;

    while (current.isSameOrBefore(end)) {
      dates.push(current.format("YYYY-MM-DD"));
      current = current.add(1, "day");
    }

    return dates;
  };

  const buildEmailChartData = (data = [], from, to) => {
    const dates = getDateList(from, to);

    // Initialize totals per date
    const totals = {};

    dates.forEach((d) => {
      totals[d] = {
        emailsSent: 0,
        emailOpened: 0,
        emailsFailed: 0,
        emailSpamComplained: 0,
        emailUnsubScribe: 0,
      };
    });

    // Aggregate all recruiters data into totals
    data.forEach((item) => {
      const date = dayjs(item?.date).format("YYYY-MM-DD");

      if (!totals[date]) return;

      totals[date].emailsSent += item?.emailsSent || 0;
      totals[date].emailOpened += item?.emailOpened || 0;
      totals[date].emailsFailed += item?.emailsFailed || 0;
      totals[date].emailSpamComplained += item?.emailSpamComplained || 0;
      totals[date].emailUnsubScribe += item?.emailUnsubScribe || 0;
    });

    // Return single merged series
    return [
      {
        seriesName: "All Recruiters",
        seriesId: 1,
        seriesData: [
          {
            name: "Email Sent",
            data: dates.map((d) => totals[d].emailsSent),
          },
          {
            name: "Email Opened",
            data: dates.map((d) => totals[d].emailOpened),
          },
          {
            name: "Email Failed",
            data: dates.map((d) => totals[d].emailsFailed),
          },
          {
            name: "Email Complained",
            data: dates.map((d) => totals[d].emailSpamComplained),
          },
          {
            name: "Email Unsubscribe",
            data: dates.map((d) => totals[d].emailUnsubScribe),
          },
        ],
      },
    ];
  };

  const emailRowCountCols = [
    // {
    //   key: "sNo",
    //   label: "S.No",
    //   columnMenu: false,
    // },
    {
      key: "reportName",
      label: "Candidate Name",
      columnMenu: false,
    },
    {
      key: "category",
      label: "Candidate Email",
      columnMenu: false,
    },
    // {
    //   key: "sentEmail",
    //   label: "Sent Email",
    //   columnMenu: false,
    //     render: (row) => (
    //     <p className="text-info-400 cursor-pointer" onClick={() => {
    //     }}>{row?.sentEmail}</p>
    //   ),
    // },
    {
      key: "sentAt",
      label: "Email Sent At",
      columnMenu: false,
    },
    {
      key: "status",
      label: "Status",
      width: 200,
      columnMenu: false,
      render: (row) => (
        <StatusTags
          tag={row.status}
          variant="contained"
          className="text-info-400"
        />
      ),
    },
  ];

  const emailChartData = useMemo(() => {
    const apiData = recruiterRows || [];

    return buildEmailChartData(apiData, dateRange.from, dateRange.to);
  }, [recruiterRows, dateRange.from, dateRange.to]);

  const emailCategories = useMemo(() => {
    return getDateList(dateRange.from, dateRange.to);
  }, [recruiterRows, dateRange.from, dateRange.to]);

  const fetchRowCountData = async () => {
    if (!activeEmailRow || !totalEmailDataCount) return;

    const statusValue = statusKey || 0;

    try {
      setLoading(true);
      const params = {
        coll: "CandidateEmailLog",
        fil: {
          emailCampaignId: {
            type: "NONE",
            value: activeEmailRow?.uiid,
          },
          status: { type: "NONE", value: statusValue },
        },
        //useAggregate: true,
        pg: canPage,
        lim: canLimit,
        ref: "Candidate",
        incl: ["uiid firstName lastName email"],
        ret: "uiid emailCampaignId addedOn addedBy status email typeOfEmail candidateId",
        extret: "uiid firstName lastName",
        errorHandler: true,
      };
      const action = candidateEmailStatus[statusValue];
      // dispatch only if valid
      if (action) {
        dispatch(action(params));
      } else {
        console.warn("No action mapped for status:", statusValue);
      }
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // dispatch(
    //   totalCountStart({
    //     collection: "submissions",
    //     coll: "Submission",
    //     tname: "sub",
    //     app: "ats",
    //     filters: { uiid: { type: "IN", value: submissionIds }, "statusHistory.status": { type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 3 } }
    //   })
    // );
    fetchRowCountData();
  }, [activeEmailRow, dispatch, canPage, canLimit]);
  useEffect(() => {
    const countRowFormattedRows = (
      emailReportData?.[emailSagaData[statusKey || 0]] || []
    ).map((item, index) => ({
      sNo: index + 1,
      // reportName: formatWords2(`${item?.addedBy?.firstName || "N/A"} ${item?.addedBy?.lastName || ""}`),
      // reportName: formatWords2(`${item?.candidateId?.firstName} ${item?.candidateId?.lastName}`) || "N/A",
      reportName:
        item?.candidateId?.firstName && item?.candidateId?.lastName
          ? formatWords2(
              item?.candidateId?.firstName + " " + item?.candidateId?.lastName,
            )
          : "N/A",
      category: item?.candidateId?.email?.primary?.email || "N/A",
      sentEmail: "Click Here",
      sentAt: convertFromUTC(item?.addedOn) || "N/A",
      status: statusMap[item?.status] || "N/A",
      uiid: item?.uiid || null,
    }));
    setEmailRowMappedData(
      mapTableRows(countRowFormattedRows, emailRowCountCols),
    );
  }, [emailReportData]);

  const generateXlsxBlobAndName = (rows, filenameBase) => {
    const rowsToWrite = rows.map((r) => ({ ...r }));
    const ws = XLSX.utils.json_to_sheet(rowsToWrite);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Email Reports");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], {
      type: "application/octet-stream",
    });

    return { blob, filename: `${filenameBase}.xlsx` };
  };

  const triggerBlobDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    showToast("Download Successful", "success", 2000);
  };

  const handleDownloadRowData = async () => {
    if (!activeEmailRow) return;
    try {
      setLoading(true);
      const statusValue = statusKey || 0;
      const params = {
        coll: "CandidateEmailLog",
        fil: {
          emailCampaignId: {
            type: "NONE",
            value: activeEmailRow?.uiid,
          },
          status: { type: "NONE", value: statusValue },
        },
        pg: canPage,
        lim: canLimit,
        ref: "Candidate",
        incl: ["uiid firstName lastName email"],
        ret: "uiid emailCampaignId addedOn addedBy status email typeOfEmail candidateId",
        extret: "uiid firstName lastName",
        errorHandler: true,
      };

      let response = await fetchEmailReportDataApi(params);

      const data = response?.data?.data || [];

      if (data?.length === 0) {
        showToast("No Data available to Download", "warning", 2000);
        return;
      }

      const exportRowsAll = (data || []).map((item, index) => ({
        "S.No": index + 1,
        "Recruiter Name": `${item?.candidateId?.firstName || "N/A"} ${item?.candidateId?.lastName || ""}`,
        Email: item?.candidateId?.email?.primary?.email || "N/A",
        "Sent At": convertFromUTC(item?.addedOn) || "N/A",
        Status: statusMap[item?.status] || "N/A",
      }));
      const dateLabel = dayjs().format("YYYY-MM-DD_HH-mm");
      //const reporterName = response?.data?.data?.[0]?.candidateId?.firstName || ""
      const filenameBase = `Reports-${dateLabel}`.replace(/__+/g, "_");

      const { blob, filename } = generateXlsxBlobAndName(
        exportRowsAll,
        filenameBase,
      );
      triggerBlobDownload(blob, filename);
    } catch (err) {
      showToast("Download unsuccessful", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  if (selectedReport) {
    if (tableType === "barChart") {
      return (
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="mr-6 mt-4 self-end">
            {/* <FormFieldSet
              noTitle
              //placeholder="Select date range"
              type="select"
              size="sm"
              value={tableType}
              options={[
                { label: "Bar Chart", value: "barChart" },
                { label: "Table", value: "table" },
              ]}
              onChange={value => { setTableType(value) }}
              shadow={true}
            /> */}
            <DropdownMenuNew
              MenuSection={({ closeDropdown }) => (
                <div className="flex flex-col bg-gray-50">
                  {[
                    tableType === "table"
                      ? {
                          label: "Bar Chart",
                          value: "barChart",
                          icon: "bar_chart",
                        }
                      : {
                          label: "Table",
                          value: "table",
                          icon: "table_chart_view",
                        },
                  ].map((it, index, arr) => (
                    <div key={it.value} className="w-full">
                      <Button
                        title={it.label}
                        icon={it.icon}
                        size="sm"
                        variant="text"
                        color={tableType === it.value ? "primary" : "black"}
                        className="p-2! justify-start w-full"
                        onClick={() => {
                          setTableType(it.value);
                          closeDropdown();
                        }}
                      />
                      {index !== arr.length - 1 && <Divider />}
                    </div>
                  ))}
                </div>
              )}
              minWidth="120px"
              maxWidth="140px"
            >
              <Button
                // title={
                //   tableType === "barChart" ? "Bar Chart" : "Table"
                // }
                // icon={
                //   tableType === "barChart"
                //     ? "bar_chart"
                //     : "table_chart_view"
                // }
                title={"Menu"}
                type="icon"
                icon={"chart_data"}
                size="md"
                color="black"
                variant="outlined"
                className="rounded! h-8 border-black/20"
              />
            </DropdownMenuNew>
          </div>
          <ChartsSetWrapperNew
            title="Email Statistics"
            type="column"
            data={emailChartData}
            categories={emailCategories}
            options={{
              dateConfig: {
                dateFilter: true,
                defaultOption: "today",
                dateRange: dateRange,
                onChange: (range) => handleDateRangeChange(range),
              },
              bar: {
                //stacked: true,
              },
            }}
          />
        </div>
      );
    }

    return (
      <div className="flex-1 flex flex-col overflow-hidden">
        <Button
          title={`${formatWords2(selectedReport?.reportName)}`}
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-lg font-semibold"
          onClick={() => setSelectedReport(null)}
        />

        <div className="flex-1 overflow-auto">
          <TableAdv
            columns={columns2}
            rows={recruiterRows}
            showCheckbox={false}
            rowClickeble={false}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            serverPagination={true}
            page={page}
            limit={limit}
            serverSearchValue={searchValue}
            // onSelectionChange={(ids) => setSelectedIds(ids)}
            showSlNo={true}
            totalCount={totalCount || 0}
            className="text-blue-600"
            tableId={"reports_ats_emailreport_recruiteremaildelivaryreport"}
            serverOnSearch={(key, value) => {
              setSearchValue(value);
            }}
            toolbarRight={{
              search: true,
              filter: true,
              download: false,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      <FormFieldSet
                        noTitle
                        placeholder="Select date range"
                        type="datepickerRange"
                        size="sm"
                        value={dateRange}
                        onChange={(range) => {
                          handleDateRangeChange(range);
                        }}
                        shadow={true}
                      />
                      <div>
                        {/* <FormFieldSet
                        noTitle
                        //placeholder="Select date range"
                        type="select"
                        size="sm"
                        value={tableType}
                        options={[
                          { label: "Bar Chart", value: "barChart" },
                          { label: "Table", value: "table" },
                        ]}
                        onChange={value => { setTableType(value) }}
                        shadow={true}
                      /> */}
                        <DropdownMenuNew
                          MenuSection={({ closeDropdown }) => (
                            <div className="flex flex-col bg-gray-50">
                              {[
                                tableType === "table"
                                  ? {
                                      label: "Bar Chart",
                                      value: "barChart",
                                      icon: "bar_chart",
                                    }
                                  : {
                                      label: "Table",
                                      value: "table",
                                      icon: "table_chart_view",
                                    },
                              ].map((it, index, arr) => (
                                <div key={it.value} className="w-full">
                                  <Button
                                    title={it.label}
                                    icon={it.icon}
                                    size="sm"
                                    variant="text"
                                    color={
                                      tableType === it.value
                                        ? "primary"
                                        : "black"
                                    }
                                    className="p-2! justify-start w-full"
                                    onClick={() => {
                                      setTableType(it.value);
                                      closeDropdown();
                                    }}
                                  />
                                  {index !== arr.length - 1 && <Divider />}
                                </div>
                              ))}
                            </div>
                          )}
                          minWidth="120px"
                          maxWidth="140px"
                        >
                          <Button
                            // title={
                            //   tableType === "barChart" ? "Bar Chart" : "Table"
                            // }
                            // icon={
                            //   tableType === "barChart"
                            //     ? "bar_chart"
                            //     : "table_chart_view"
                            // }
                            title={"Menu"}
                            type="icon"
                            icon={"chart_data"}
                            size="md"
                            color="black"
                            variant="outlined"
                            className="rounded! h-8 border-black/20"
                          />
                        </DropdownMenuNew>
                      </div>
                    </div>
                  ),
                },
              ],
              //order: ["search",   "add","filter",],
            }}
          />
        </div>
        <Modal
          isOpen={isModelopen}
          onClose={() => {
            setIsModelOpen(false);
            setActiveEmailRow();
            setTotalEmailDataCount();
            setStatusKey(0);
            canSetPage(1);
            //canHandleLimitChange(25)
          }}
          title={`Email Statistics - ${statusMap[statusKey]}`}
          titleColor={"primary"}
          width="max-w-7xl"
        >
          <TableAdv
            showSlNo
            rows={emailRowMappedData}
            columns={emailRowCountCols}
            serverPagination={true}
            totalCount={totalEmailDataCount}
            page={canPage}
            limit={canLimit}
            onPaginationChange={canSetPage}
            onLimitChange={canHandleLimitChange}
            toolbarRight={{
              //search: true,
              //download: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      <Button
                        //type="icon"
                        className="bg-primary-500 "
                        variant="text"
                        color="white"
                        title="Export"
                        //icon="ios_share"
                        onClick={handleDownloadRowData}
                      />
                    </div>
                  ),
                },
              ],
            }}
          />
        </Modal>
        <Backdrop isOpen={loading} zIndex={53}>
          <LogoLoader />
        </Backdrop>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <TableAdv
        disableSelection={true}
        columns={columns}
        rows={mappedRows}
        showCheckbox={false}
        showSlNo
        toolbarRight={{ search: true }}
        tableId={"emailReportsTable"}
      />
    </div>
  );
};

export default EmailReports;

// import React, { useState, useEffect } from "react";
// import { Button, FormFieldSet, TableAdv } from "../../../../components";
// import { mapTableRows } from "../../../../utils";
// import { useDispatch, useSelector } from "react-redux";
// import { recruiterEmailDelivaryReportStart } from "../../../../redux/slices/reports/reportsSlice";
// import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
// import { usePagination } from "../../../../hooks";
// import { formatWords2 } from "../../../../utils/stringUtils";

// const EmailReports = ({ selectedReport, setSelectedReport }) => {
//   const dispatch = useDispatch();
//   const { recruiterEmailDelivaryReport } = useSelector((state) => state.reports) || {};

//   const { page, limit, setPage, handleLimitChange } = usePagination(
//     10,
//     (newPage, newLimit) => { }
//   );

//   const [dateRange, setDateRange] = useState(() => {
//     const today = new Date();
//     const before10Days = new Date();
//     before10Days.setDate(today.getDate() - 10);
//     return { from: new Date(), to: new Date(), };
//   });
//   const [recruiterRows, setRecruiterRows] = useState([]);
//   const [selectedIds, setSelectedIds] = useState([]);

//   const handleDateRangeChange = (range) => {
//     if (!range || !range.from || !range.to) return;
//     const fromISO = range.from ? range.from : null;
//     const toISO = range.to ? range.to : null;
//     setDateRange({ from: fromISO, to: toISO });
//   };
//   const { user } = useSelector((state) => state.auth);

//   const reportOptions = [
//     { id: "reports_ats_emailreport_recruiteremaildelivaryreport", name: "Recruiter Email Delivary Report" },
//   ];

//   const rows = reportOptions.map((report, i) => ({
//     id: i + 100,
//     reportName: report,
//     category: "Email Report",
//     type: "Standard Reports",
//     // Favourite: "iii",
//   }));

//   const columns = [
//     {
//       key: "reportName",
//       label: "Report Name",
//       render: (row) => (
//         <div
//           className="text-blue-600 cursor-pointer"
//           onClick={() => setSelectedReport(row?.reportName?.id)}
//         >
//           {row?.reportName?.name}
//         </div>
//       ),
//     },
//     {
//       key: "category",
//       label: "Category",
//     },
//     {
//       key: "type",
//       label: "Type",
//     },
//     {
//       key: "Favourite",
//       label: "Favourite",
//       render: (row) => (
//         <Button
//           type="icon"
//           icon={"star"}
//           variant="text"
//           size="md-lg"
//           color="black"
//           className="text-gray-400"
//         // onClick={() => console.log("delete", row)}
//         />
//       ),
//     },
//   ];

//   const columns2 = [
//     {
//       key: "date",
//       label: "Date",
//       width: "text-nowrap!",
//     },
//     {
//       key: "recruiterName",
//       label: "Recruiter Name",
//       width: "text-nowrap!",
//     },
//     {
//       key: "emailsQueued",
//       label: "Emails Queued",
//     },
//     {
//       key: "emailsSent",
//       label: "Emails Sent",
//     },
//     {
//       key: "emailsFailed",
//       label: "Emails Failed",
//     },
//     {
//       key: "emailClicked",
//       label: "Emails Clicked",
//     },
//     {
//       key: "emailOpened",
//       label: "Emails Opened",
//     },
//     {
//       key: "emailTemporaryFailed",
//       label: "Emails Temporary Failed",
//     },
//     {
//       key: "emailPermanentFailed",
//       label: "Emails Permanent Failed",
//     },
//     {
//       key: "emailSpamComplained",
//       label: "Emails Spam Complained",
//     },
//     {
//       key: "emailUnsubScribe",
//       label: "Emails UnSubscribe",
//     },
//     {
//       key: "Favourite",
//       label: "Favourite",
//       render: (row) => (
//         <Button
//           type="icon"
//           icon={"star"}
//           variant="text"
//           size="md-lg"
//           color="black"
//           className="text-gray-400"
//         // onClick={() => console.log("delete", row)}
//         />
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(rows, columns);
//   const fetchRecruiterEmailDelivaryReports = () => {
//     let userId = user?.data?.role?.type == 4 ? user?.data?.uiid : ""
//     const payload = {
//       coll: "CandidateEmailLog",
//       fil: {
//         addedOn: { type: "CANDIDATE_EMAIL_DELIVERY_REPORT", value: [getStartOfDay(dateRange?.from), getEndOfDay(dateRange?.to)], ...( userId && {userId: userId}) }
//       },
//       useAggregate: true,
//       lim: limit,
//       extret: "uiid firstName lastName role.type"
//     };
//     dispatch(recruiterEmailDelivaryReportStart(payload));
//   };

//   useEffect(() => {
//     fetchRecruiterEmailDelivaryReports();
//   }, [dateRange, limit, page]);

//   useEffect(() => {
//     const rows = recruiterEmailDelivaryReport?.[0]?.data?.map((report, i) => ({
//       id: i + 100,
//       date: report?.addedOn,
//       recruiterName: formatWords2(report?.addedBy?.firstName) + " " + formatWords2(report?.addedBy?.lastName),
//       emailsQueued: report?.emailsQueued || 0,
//       emailsSent: report?.emailsSent || 0,
//       emailsFailed: report?.emailsFailed || 0,
//       emailsSkipped: report?.emailsSkipped || 0,
//       emailOpened: report?.emailOpened || 0,
//       emailClicked: report?.emailClicked || 0,
//       emailTemporaryFailed: report?.emailTemporaryFailed || 0,
//       emailPermanentFailed: report?.emailPermanentFailed || 0,
//       emailSpamComplained: report?.emailSpamComplained || 0,
//       emailUnsubScribe: report?.emailUnsubScribe || 0,
//     }));
//     setRecruiterRows(rows);
//   }, [recruiterEmailDelivaryReport])

//   if (selectedReport) {
//     const reportData = rows?.find((r) => r?.reportName?.id === selectedReport);

//     return (
//       <div className="flex-1 flex flex-col overflow-hidden">
//         <Button
//           title={`${formatWords2(selectedReport?.reportName)}`}
//           color="black"
//           variant="text"
//           size="md"
//           fromLeft
//           icon="arrow_left_alt"
//           className="self-start text-lg font-semibold"
//           onClick={() => setSelectedReport(null)}
//         />

//         <div className="flex-1 overflow-auto">
//           <TableAdv
//             columns={columns2}
//             rows={recruiterRows}
//             showCheckbox={false}
//             rowClickeble={false}
//             onPaginationChange={setPage}
//             onLimitChange={handleLimitChange}
//             serverPagination={true}
//             // onSelectionChange={(ids) => setSelectedIds(ids)}
//             showSlNo={true}
//             totalCount={recruiterEmailDelivaryReport?.[0]?.totalCount || 0}
//             className="text-blue-600"
//             tableId={"reports_ats_emailreport_recruiteremaildelivaryreport"}
//             toolbarRight={{
//               search: true,
//               filter: true,
//               download: false,
//               add: [{
//                 component: (
//                   <div className="flex items-center gap-2">
//                     <FormFieldSet
//                       noTitle
//                       placeholder="Select date range"
//                       type="datepickerRange"
//                       size="sm"
//                       value={dateRange}
//                       onChange={range => { handleDateRangeChange(range) }}
//                       shadow={true}
//                     />
//                   </div>
//                 )
//               }]
//             }}
//           />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex-1 flex flex-col overflow-hidden">
//       <TableAdv
//         disableSelection={true}
//         columns={columns}
//         rows={mappedRows}
//         showCheckbox={false}
//         showSlNo
//         toolbarRight={{ search: true }}
//         tableId={"emailReportsTable"}
//       />
//     </div>
//   );
// };

// export default EmailReports;
